export enum LanguageEnums {
  EN = 1,
  FR = 2,
  ES = 3,
}
